import { useState } from "react";
import styled, { keyframes } from "styled-components";

//style tutaj na dole
const appear = keyframes`
        from {
          padding-top: 10vh;
          opacity: 0;

        }
        to {
          padding-top: 0;
          opacity: 1;

        }
      `;

const typing = keyframes`
      0% {
        width: 0%;
        text-shadow: 0px 0px 6px #f8ffe8;
      }
      80%{text-shadow: 0px 0px 6px #f8ffe8;}
      100% {
        width: 640px;
        text-shadow: 0px 0px 0px #f8ffe8;
      }
      
      `;

const typingTwo = keyframes`
      0% {
        width: 0%;
        text-shadow: 0px 0px 6px #f8ffe8;
      }
      80%{text-shadow: 0px 0px 6px #f8ffe8;}
      100% {
        width: 640px;
        text-shadow: 0px 0px 0px #f8ffe8;
      }
      
      `;

const typinghelp = keyframes`
      0% {
        width: 0%;
        text-shadow: 0px 0px 6px #f8ffe8;
      }
      80%{text-shadow: 0px 0px 6px #f8ffe8;}
      100% {
        width: 345px;
        text-shadow: 0px 0px 0px #f8ffe8;
      }
      
      `;
const typing2 = keyframes`
0% {
  text-shadow: 0px 0px 0px #f8ffe8;
}
40%{text-shadow: 0px 0px 6px #f8ffe8;}
80%{text-shadow: 0px 0px 6px #f8ffe8;}
100% {

  text-shadow: 0px 0px 0px #f8ffe8;
}
`;
const blinkCaret = keyframes`
      from,
      to {
      border-color: transparent;
      }
      50% {
      border-color: orange;
      }`;
const Ikony = styled.div`
  height: auto;
  width: 100%;
  display: flex;

  flex-direction: column;
  background-color: #333d1d;
  color: #798460;
  justify-content: space-around;
  animation-name: ${appear};
  animation-duration: 0.6s;
`;
const BigTitle = styled.div`
  display: flex;
  align-items: center;
  height: auto;
  & > h1 {
    width: auto;
    color: #798460;
    font-weight: normal;
    margin-left: 3vw;
    font-size: 12vh;
  }
  @media only screen and (max-width: 1439px) {
    height: 50vh;
    flex-direction: column;
    align-items: center;
    white-space: normal;
    & > h1 {
      margin-left: 0;
    }
  }
  @media only screen and (max-width: 800px) {
    & > h1 {
      font-size: 8vh;
    }
    height: 45vh;
  }
  @media only screen and (max-width: 450px) {
    & > h1 {
      font-size: 6vh;
    }
    height: 25vh;
  }
`;

const BeltForIkony = styled.div`
  width: 100%;
  height: 45vh;
  display: flex;
  justify-content: center;

  @media only screen and (max-width: 800px) {
    height: 35vh;
  }
`;

const Ikona = styled.div`
  width: 25%;
  height: 100%;
  margin: 0 4%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-radius: 2vh;
  background-color: #2e1919;
  color: #798460;
  cursor: pointer;
  & > h1 {
    margin: 2vh;
    font-size: 42px;
    transition: 0.3s;
  }
  & > p {
    margin: 2%;
    color: #798460;
    text-align: center;
    transition: 0.3s;
    opacity: 0;
  }
  & > svg {
    margin-top: 4vh;
    fill: #f8ffe8;
    width: 150px;
    height: 150px;
    transition: 0.3s;
  }

  &:hover > h1 {
    transform: scale(1.1) translateY(-2vh);
    transition: 0.3s;
    color: #f8ffe8;
    text-shadow: 0px 0px 0.4vh #f8ffe8;
  }
  &:hover > p {
    transform: translateY(-2vh);
    transition: 0.3s;
    color: #f8ffe8;
    text-shadow: 0px 0px 0.2vh #f8ffe8;
    opacity: 1;
  }
  &:hover > svg {
    transform: scale(1.2);
    transition: 0.3s;
    filter: drop-shadow(0 0 0.2vh #798460);
    fill: #798460;
  }
  @media only screen and (max-width: 1280px) {
    width: 30%;
  }
  @media only screen and (max-width: 800px) {
    width: 40%;
    & > h1 {
      font-size: 20px;
    }
    & > p {
      display: none;
    }
    & > svg {
      width: 100px;
      height: 100px;
    }
  }
`;

const Typewriter = styled.div`
  margin-top: 1.5vh;
  margin-left: 2vw;
  display: inline;
  color: #dc6969;
  font-size: 9vh;
  width: 650px;

  overflow: hidden; /* Ensures the content is not revealed until the animation */
  border-right: 0.15em solid orange; /* The typwriter cursor */
  white-space: nowrap; /* Keeps the content on a single line */
  /* Gives that scrolling effect as the typing happens */
  letter-spacing: 0.15em; /* Adjust as needed */
  animation: ${typing} 0.75s steps(13, end),
    ${blinkCaret} 0.75s step-end infinite;
  @media only screen and (max-width: 1400px) {
    width: 620px;
    animation: ${typingTwo} 0.75s steps(13, end),
      ${blinkCaret} 0.75s step-end infinite;
  }
  @media only screen and (max-width: 800px) {
    font-size: 5vh;
    animation: ${typinghelp} 0.75s steps(13, end),
      ${blinkCaret} 0.75s step-end infinite;
    width: 400px;
  }
  @media only screen and (max-width: 400px) {
    font-size: 4.5vh;
    animation: ${typinghelp} 0.75s steps(13, end),
      ${blinkCaret} 0.75s step-end infinite;
    width: 345px;
  }
`;

const BeltForRedirect = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #798460;
  text-align: center;
  & > h1 > br {
    display: none;
  }
  & > h1 > span {
    color: #f8ffe8;
    animation: ${typing2};
    animation-duration: 1.5s;
  }
  & > h1 > span:last-child {
    background-color: #f8ffe8;
    color: #798460;
    padding: 1vh;
  }
  @media only screen and (max-width: 1050px) {
    font-size: 18px;
  }
  @media only screen and (max-width: 800px) {
    font-size: 15px;
    line-height: 60px;
    & > h1 > br {
      display: block;
    }
  }
`;

const Kreska = styled.div`
  opacity: 0;
  transition: 0.5s;
  margin-top: 2vh;
  width: 90%;
  height: 0.5vh;
  background-color: #f8ffe8;
`;

const Strzalka = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
  height: auto;
  align-self: center;
  @media screen and (max-width: 479px) {
    width: 90%;
  }

  & > svg {
    width: 80px;
    height: 80px;
    transition: 0.3s;
  }
  &:hover > ${Kreska} {
    margin-top: 4vh;
    opacity: 1;
    box-shadow: 0px 0px 24px 0px #f8ffe8;
    width: 90%;
  }

  &:hover > svg {
    margin-top: 1vh;
    fill: #f8ffe8;
  }
`;

function Ikonki() {
  //Ikony SVG
  var strzaleczka = (
    <svg
      fill="#E9F8F9"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="800px"
      height="800px"
      viewBox="0 0 100 100"
      enableBackground="new 0 0 100 100"
      xmlSpace="preserve"
    >
      <g>
        <path d="M49.288,59.647c0.383,0.348,0.863,0.519,1.342,0.519c0.076,0,0.151-0.015,0.228-0.023c0.028,0.001,0.057,0.008,0.085,0.008c0.545,0,1.088-0.222,1.482-0.657l15.231-16.804c0.742-0.818,0.68-2.083-0.139-2.824c-0.818-0.743-2.083-0.679-2.824,0.139 L50.656,55.49L35.169,41.453 c-0.819-0.744-2.083-0.68-2.824,0.139 c-0.742,0.818-0.68,2.083,0.139,2.824L49.288,59.647z" />
        <path d="M50,83.214c18.449,0,33.458-15.009,33.458-33.457c0-18.449-15.009-33.458-33.458-33.458c-18.448,0-33.457,15.009-33.457,33.458C16.543,68.205,31.552,83.214,50,83.214z M50,20.299c16.243,0,29.458,13.215,29.458,29.458c0,16.242-13.215,29.457-29.458,29.457c-16.242,0-29.457-13.215-29.457-29.457C20.543,33.514,33.758,20.299,50,20.299z" />
      </g>
    </svg>
  );
  var wideo = (
    <svg
      className="Wideo"
      fill="#333d1d"
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17 10.5V7C17 6.73478 16.8946 6.48043 16.7071 6.29289C16.5196 6.10536 16.2652 6 16 6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V17C3 17.2652 3.10536 17.5196 3.29289 17.7071C3.48043 17.8946 3.73478 18 4 18H16C16.2652 18 16.5196 17.8946 16.7071 17.7071C16.8946 17.5196 17 17.2652 17 17V13.5L21 17.5V6.5L17 10.5ZM8 15V9L12.5 12L8 15Z" />
    </svg>
  );

  var code = (
    <svg
      fill="#333d1d"
      version="1.1"
      className="Code"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 392.186 392.186"
      xmlSpace="preserve"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <g>
            {" "}
            <g>
              {" "}
              <path d="M368.62,17.951H23.568C10.57,17.951,0,28.524,0,41.52v309.146c0,12.996,10.57,23.568,23.568,23.568h345.053 c12.994,0,23.564-10.572,23.564-23.568V41.52C392.188,28.525,381.614,17.951,368.62,17.951z M297.56,57.528 c0-4.806,3.896-8.703,8.701-8.703h8.703c4.808,0,8.701,3.896,8.701,8.703v9.863c0,4.806-3.896,8.702-8.701,8.702h-8.703 c-4.805,0-8.701-3.896-8.701-8.702V57.528z M257.093,57.528c0-4.806,3.898-8.703,8.703-8.703h8.701 c4.805,0,8.703,3.896,8.703,8.703v9.863c0,4.806-3.898,8.702-8.703,8.702h-8.701c-4.805,0-8.703-3.896-8.703-8.702V57.528z M363.903,345.951H28.282V102.235h335.621V345.951L363.903,345.951z M364.132,67.391c0,4.806-3.896,8.702-8.701,8.702h-8.703 c-4.809,0-8.702-3.896-8.702-8.702v-9.863c0-4.806,3.896-8.703,8.702-8.703h8.703c4.806,0,8.701,3.896,8.701,8.703V67.391z"></path>{" "}
              <path d="M84.185,233.284l63.084,29.336c1.631,0.755,3.367,1.138,5.162,1.138c2.338,0,4.617-0.664,6.598-1.924 c3.547-2.267,5.666-6.13,5.666-10.334v-0.322c0-4.752-2.785-9.116-7.096-11.118l-39.455-18.332l39.455-18.334 c4.311-2.004,7.096-6.367,7.096-11.117v-0.319c0-4.21-2.119-8.075-5.666-10.334c-1.961-1.253-4.246-1.916-6.605-1.916 c-1.779,0-3.563,0.391-5.16,1.133l-63.08,29.333c-4.307,2.004-7.09,6.369-7.09,11.117v0.877 C77.093,226.909,79.874,231.272,84.185,233.284z"></path>{" "}
              <path d="M165.257,293.036c2.301,3.149,6.002,5.03,9.9,5.03h0.316c5.352,0,10.041-3.426,11.672-8.517L228.7,160.788 c1.192-3.716,0.531-7.818-1.771-10.973c-2.301-3.15-6.002-5.03-9.901-5.03h-0.315c-5.354,0-10.048,3.425-11.679,8.516 l-41.559,128.771C162.292,285.793,162.958,289.889,165.257,293.036z"></path>{" "}
              <path d="M227.49,192.276c0,4.745,2.783,9.109,7.095,11.123l39.455,18.329l-39.455,18.33c-4.31,2.004-7.095,6.368-7.095,11.118 v0.322c0,4.205,2.117,8.068,5.668,10.336c1.974,1.258,4.254,1.924,6.595,1.924c1.793,0,3.528-0.383,5.17-1.142l63.08-29.335 c4.307-2.009,7.09-6.372,7.09-11.115v-0.877c0-4.748-2.783-9.113-7.094-11.117l-63.08-29.333 c-1.591-0.74-3.373-1.131-5.152-1.131c-2.355,0-4.643,0.661-6.604,1.912c-3.551,2.263-5.67,6.127-5.67,10.337v0.318H227.49 L227.49,192.276z"></path>{" "}
            </g>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );

  //Inna logika
  const [tekst1, w1] = useState(false);
  const [tekst2, w2] = useState(false);

  const handleClickScroll = () => {
    const element = document.getElementById("jump");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const weber = (
    <Typewriter style={{ color: "#C0EEF2" }}>&lt;WebDevem&#x2F;&gt;</Typewriter>
  );
  const monter = <Typewriter>&lt;Montażystą&#x2F;&gt;</Typewriter>;
  //render
  return (
    <Ikony>
      <BigTitle>
        <h1>Cześć, jestem: </h1>
        {tekst1 && monter}
        {tekst2 && weber}
      </BigTitle>
      <BeltForIkony>
        <Ikona
          onMouseOver={() => {
            w1(true);
            w2(false);
          }}
          onClick={handleClickScroll}
        >
          {wideo}
          <h1>Montażystą</h1>
          <p>
            Od Windows Movie Maker w wieku 6 lat do wieloletniego doświadczenia
            w Premiere Pro oraz After Effects w wieku 18 lat
          </p>
        </Ikona>

        <Ikona
          onMouseEnter={() => {
            w1(false);
            w2(true);
          }}
          onClick={handleClickScroll}
        >
          {code}
          <h1>webDevem</h1>
          <p>
            Tworze hobbistycznie strony od ostatnich 5 lat, z FrontDeveloperką
            na czele. Posiadam więdzę w CSS, JS oraz React{" "}
          </p>
        </Ikona>
      </BeltForIkony>
      <BeltForRedirect>
        <h1 style={{ marginTop: "3vh" }}>
          Albo inaczej: <span>Daniel Szota</span>. <br />
          <span> Zobacz moje portfolio tutaj</span>
        </h1>
        <Strzalka onClick={handleClickScroll}>
          <Kreska />
          {strzaleczka}
        </Strzalka>
      </BeltForRedirect>
    </Ikony>
  );
}
export default Ikonki;
